<ng-template #templateRef>
  <div class="p-inputgroup">
    <p-multiSelect #multiselectRef
                   scrollHeight="400px"
                   dataKey="id"
                   optionLabel="name"
                   appendTo="body"
                   [showToggleAll]="false"
                   [options]="itemsSource"
                   [filter]="multiselectRef.options?.length > 10"
                   [showHeader]="true"
                   [placeholder]="placeholder"
                   [(ngModel)]="multiselectFilterValues"
                   (onChange)="onSelectionChange()">
      <ng-template #header>
        <div class="p-3">
          <span class="font-bold">{{groupsLabel}}</span>

          @for (groupItem of groupListItems; track groupItem; let i = $index) {
            <div class="field-checkbox mt-4 mb-4 flex align-items-center">
              <p-checkbox [(ngModel)]="selectedGroups"
                          [value]="groupItem.value"
                          (onChange)="onSelectedGroupsChange(multiselectRef, groupItem.value)"
                          [scIndeterminateCheckbox]="isNotAllGroupValuesSelected(groupItem.value)"
                          [inputId]="'group-' + i" />
              <label [for]="'group-' + i"
                     class="ml-2">{{ groupItem.label }}</label>
            </div>
          }

          <span class="font-bold">{{itemsLabel}}</span>
        </div>
      </ng-template>
    </p-multiSelect>
    @if (isFilterApplied) {
      <button pButton
              type="button"
              icon="pi pi-times"
              (click)="cleanFilter()"></button>
    }
  </div>
</ng-template>